/* eslint-disable */

import React from 'react';
import PropTypes from 'prop-types';

const KeyVal = ((props) => {
  const { label, error, defaultValue, key1 } = props;  
  const hexValArr = ['matterProductId', 'commissioningHint1', 'commissioningHint2', 'availableMaxVer', 'availableMinVer', 'cdVersion', 'majorVersion', 'productId'];

  return (
    <>
      <se-form-field
        label={label}
        option='inline'
        block
        label-align='left'
        data-testid='keyVal'
        style={{ marginLeft: 0 }}
      >
        <div style={{ display: 'flex', position: 'relative', alignItems: 'center' }}>
            {Array.isArray(defaultValue) ? JSON.stringify(defaultValue) : hexValArr.includes(key1) ? defaultValue + ' (0x' + Number(defaultValue).toString(16).toUpperCase() + ')' : defaultValue}
        </div>
      </se-form-field>
      {error && <span className='errorMsg'>{error}</span>}
    </>
  );
});

export default KeyVal;

KeyVal.propTypes = {
  label: PropTypes.string.isRequired,
  error: PropTypes.string,
  type: PropTypes.string,
};

KeyVal.defaultProps = {
  defaultValue: null,
};
